export default {
  pledgeLoanPendingReview: "待審核",
  pledgeLoanOverdue: "已逾期",
  pledgeLoanName: "質押借貸",
  pledgeLoanInterest: "利息",
  pledgeLoanMaturityDate: "到期日期",
  pledgeLoanHeroTitle: "最大化利用你的數位資產，賺取更多收益！",
  pledgeLoanCurrency: "幣種",
  pledgeLoanApplicationDate: "申請日期",
  pledgeLoanCollateralTerm: "質押週期",
  pledgeLoanHeroSubtitle: "促銷活動期間，質押利息為0",
  pledgeLoanRejected: "已拒絕",
  pledgeLoanBorrowAmount: "借貸數量",
  pledgeLoanReviewDate: "審核日期",
  pledgeLoanWithdrawalWarning: "您有未結清的質押借貸訂單，請結清後再申請提領現",
  pledgeLoanRepayment: "還款",
  pledgeLoanUnpayAmount: "待還金額",
  pledgeLoanRepayTime: "結清時間",
  pledgeLoanCollateralAmount: "質押數量",
  pledgeLoanCollateralRatio: "倍數",
  pledgeLoanInProgress: "進行中",
  pledgeLoanSettled: "已結清",
  pledgeLoanApplyNow: "立即申請",
  pledgeLoanFinishedText: "沒有更多資料",
  pledgeLoanPreviewOnly: "目前僅供預覽，尚未提交申請。",
  required: '必填',
  home: '首頁',
  market: '行情',
  currency: '現貨',
  walletTrade: '現貨帳戶', // 资产 币币
  contract: '合約',
  wallet: '資產',
  pulling: '下拉即可刷新...',
  loosing: '釋放即可刷新...',
  loading: '加載中...',
  loadingError: '加載失敗',
  nothing: '暫無數據',
  finished: '',
  price: '價格',
  number: '數量',
  recharge: '充值',
  transfer: '劃轉',
  invite: '邀請好友',
  inviteDes: '叫上小伙伴一起玩吧',
  contact: '聯繫我們',
  contactDes: '7*24小時在線',
  fastTrade: '秒合約',
  name: '名稱',
  fastPrice: '最新價',
  trend: '漲跌幅',
  all: '全部',
  growthList: '漲幅榜',
  loserList: '跌幅榜',
  vol: '24H額',
  buy: '買入',
  sell: '賣出',
  optimal: '以當前最優價格交易',
  marketOrder: '市價交易',
  limitOrder: '限價交易',
  useable: '可用',
  tradeVol: '交易額',
  entrust: '當前委託',
  entrustTotal: '委託總額',
  noLogin: '暫未登錄，',
  toLogin: '去登錄',
  cancelOrder: '撤單',
  cancelError: '撤單失敗',
  cancelSuccess: '撤單成功',
  cancelTip: '確認要撤銷委託？',
  completed: '已完成',
  canceled: '已取消',
  marketPrice: '市價',
  limitPrice: '限價',
  entrustPrice: '委託價',
  entrustNum: '委託量',
  currencyType: '幣種',
  headerCurrencyType: '幣種',
  currencyOrder: '幣幣交易訂單',
  history: '歷史記錄',
  tryAgain: '請重新嘗試',
  entrustPriceTip: '請輸入委託價格',
  tradeNumTip: '請輸入交易數量',
  tradeNumLess: '交易數量要大於0',
  numLessTip: '餘額不足',
  tradePriceTip: '請輸入交易額',
  balanceTip: '餘額不足',
  tradeError: '交易失敗',
  tradeSuccess: '交易成功',
  tip: '溫馨提示',
  tradeConfirm: '確認交易？',
  cancelText: '取消',
  confirmText: '確認',
  toBuy: '買漲',
  toSell: '賣空',
  confirmToBuy: '買漲',
  confirmToSell: '賣空',
  slPrice: '止損價格',
  sl: '止損',
  tp: '止盈',
  tpPrice: '止盈價格',
  currentOrder: '當前訂單',
  historyOrder: '歷史訂單',
  setting: '設置',
  unwind: '平倉',
  handUnwind: '手動平倉',
  futuresPay: '',
  forceUnwind: '強平',
  slTp: '止盈止損',
  fastTradeUnwind: '秒合約平倉',
  blowUp: '爆倉',
  openNum: '數量',
  warrant: '擔保資產',
  openPrice: '開倉價格',
  fee: '手續費',
  profit: '盈虧',
  lastPrice: '最新價格',
  unwindPrice: '平倉價格',
  unwindError: '平倉失敗',
  unwindSuccess: '平仓成功',
  setSuccess: '設置成功',
  setError: '設置失敗',
  setSlTp: '設置止盈/止損',
  second: '秒',
  multiple: '倍數',
  direction: '方向',
  tradeCurrency: '交易貨幣',
  loss: '虧',
  fill: '盈',
  executePrice: '執行價格',
  currentPrice: '現價',
  closePrice: '結算價',
  secondNum: '週期',
  contractOrder: '合約訂單',
  fastTradeOrder: '秒合約訂單',
  overview: '資產總覽', 
  ieoBuy: '新幣',
  ieoBuy1: '新幣賬戶',
  balanceTotal: '總賬戶資產折合',
  withdraw: '提現',
  tradeOrder: '交易訂單',
  rechargeHistory: '充值記錄',
  withdrawHistory: '提現記錄',
  freeze: '凍結',
  amountTo: '折合',
  tipText: '提示',
  ieoTip: 'IEO暫未開始，請耐心等候！',
  financeList: '財務記錄',
  currencyAccount: '現貨帳戶',
  contractAccount: '合約賬戶',
  time: '時間',
  status: '狀態',
  balanceTyle: '資產類型',
  pay: '支出',
  income: '收入',
  lastBalance: '當前餘額',
  orderNo: '單號',
  money: '金額',
  date: '日期',
  finallyIncome: '實際到賬',
  commitMoney: '提交金額',
  orderNum: '訂單號',
  waitReview: '確認中',
  reviewPass: '審核通過',
  reviewReject: '審核拒絕',
  waitWallet: '待审核',
  walletPass: '錢通過',
  walletReject: '拒絕',
  withdrawSuccess: '提現成功',
  withdrawError: '轉賬失敗',
  high24H: '24H高',
  low24H: '24H低',
  num24H: '24H量',
  minute: '分鐘',
  hour: '小時',
  day: '天',
  week: '週',
  markets: '行情',
  open: '開',
  close: '收',
  high: '高',
  low: '低',
  volume: '成交量',
  fastLogin: '立即登錄',
  register: '註冊',
  auth: '實名認證',
  authSuccess: '已認證',
  noPass: '審核未通過',
  authCommit: '提交待審核',
  onAuth: '未認證',
  onLogin: '未登錄',
  securitySet: '安全設置',
  userAgree: '用戶支持',
  aboutUs: '關於我們',
  logout: '退出登錄',
  logoutSuccess: '退出成功',
  lookAuthInfo: '查看認證信息',
  authAgain: '重新認證',
  authInfo: '認證信息',
  account: '賬號',
  countryArea: '國家/地區',
  idNo: '證件號碼',
  idNoTip: '請輸入您的證件號碼',
  email: '郵箱',
  emailInput: '請輸入郵箱',
  setLoginPwd: '設置登錄密碼',
  loginPwdInput: '請輸入登錄密碼（8-20位字符）',
  loginPwdTip: '請輸入登錄密碼',
  loginPwdLen: '登錄密碼應為8-20位字符',
  setFinancePwd: '設置資金密碼',
  financePwdInput: '請輸入資金密碼（6-20位字符）',
  financePwdTip: '請輸入資金密碼',
  financePwdLen: '資金密碼應為6-20位字符',
  inviteCode: '邀請碼',
  inviteCodeTip: '請輸入邀請碼',
  inviteInput: '邀請碼必填',
  imageCode: '圖形驗證碼',
  imageCodeInput: '請輸入驗證碼',
  registerTip: '繼續註冊即代表同意',
  agree: '《用戶協議》',
  agreeText: '用戶協議',
  next: '下一步',
  registerSuccess: '註冊成功',
  registerError: '註冊失敗',
 securityCheck: '安全驗證',
googleAuthenticator: `Google 驗證器`,
googleAuthBoundTitle: `此帳戶已啟用 Google 驗證器。`,
googleAuthBoundDesc: `Google 驗證器正在為你的帳戶提供額外保護。`,
googleAuthEnableTitle: `啟用 Google 驗證器`,
googleAuthEnableDesc: `為你的帳戶增加一層額外保護。`,
googleAuthScanTip: `使用 Google 驗證器掃描二維碼，然後輸入 6 位數驗證碼。`,
googleAuthConfirm: `確認綁定`,
googleAuthCodeTitle: `Google 驗證`,
googleAuthCodeDesc: `請輸入 Google 驗證器中的 6 位數驗證碼。`,
googleAuthCodeInput: `請輸入 Google 驗證碼`,
googleAuthBindSuccess: `Google 驗證器啟用成功`,
googleAuthLoadError: `Google 驗證器載入失敗`,
googleAuthSecret: `秘密金鑰`,
googleAuthCopySecret: `複製秘密金鑰`,
  checkCodeInput: '請輸入郵箱驗證碼',
  sendCheckCode: '發送驗證碼',
  sendSuccess: '發送成功',
  sendError: '發送失敗',
  welcome: '歡迎登錄',
  loginEmail: '登錄郵箱',
  loginEmailInput: '請輸入登錄郵箱',
  loginPwd: '登錄密碼',
  login: '登錄',
  forgetPwd: '忘記密碼',
  loginTip: '繼續登錄即代表同意',
  loginSuccess: '登錄成功',
  loginError: '登錄失敗',
  fullname: '姓名',
  fullnameTip: '請輸入您的姓名',
  country: '國家/地區',
  countryTip: '請輸入您的國家/地區',
  imgFront: '請上傳證件正面照片',
  imgReverse: '請上傳證件反面照片',
  commit: '提交',
  commitSuccess: '提交成功',
  commitError: '提交失敗',
  selectCurrency: '請選擇幣種',
  rechargeNet: '充值網絡',
  rechargeAddress: '充值地址',
  copyAddress: '複製地址',
  minRecharge: '最小充值金額',
  copySuccess: '複製成功',
  copyError: '複製失敗',
  withdrawTip: '實名認證後才可提現',
  withdrawAddress: '提現地址',
  withdrawAddressInput: '請輸入提現地址',
  withdrawNet: '提現網絡',
  withdrawNum: '提現金額',
  withdrawNumInput: '請輸入提現金額',
  withdrawNumLess: '餘額不足',
  withdrawMin: '最小提現金額',
  balanceUse: '可用餘額',
  actualMoney: '實際到賬金額約',
  actualMoneyText: '到賬金額',
  financePwd: '資金密碼',
  trade: '',
  withdrawFail: '提現失敗',
  commitTime: '提交時間',
  from: '從',
  to: '到',
  transferMoney: '請輸入劃轉金額',
  transferSuccess: '劃轉成功',
  transferError: '劃轉失敗',
  transferHistory: '劃轉記錄',
  updateFinancePwd: '修改資金密碼',
  confirmPwd: '確認密碼',
  confirmPwdInput: '請輸入確認密碼',
  updatePwd: '修改密碼',
  updatePwdSuccess: '密碼修改成功',
  updatePwdError: '密碼修改失敗',
  noAlike: '密碼輸入不一致',
  emailUpdate: '郵箱修改',
  loginPwdUpdate: '登錄密碼修改',
  financePwdUpdate: '資金密碼修改',
  newEmail: '新的郵箱',
  emailUpdateTip: '輸入新的郵箱賬號',
  checkEmail: '驗證郵箱',
  updateEmail: '修改郵箱',
  updateEmailError: '郵箱修改失敗',
  updateEmailSuccess: '郵箱修改成功',
  checkError: '驗證失敗',
  pwdLen: '8-20位密碼',
  inviteUrl: '我的邀請鏈接',
  myInviteCode: '我的邀請碼',
  fastInvite: '立即邀請',
  myInvite: '我的邀請',
  registerTime: '註冊時間',
  bulletin: '公告',
  inviteFriend: '邀請好友',
  saveAccount: '保存賬號密碼',
  indicator: '指標',
  type: '類型',
  amount: '金額',
  scanError: '圖片識別失敗',
  scanInitErr: '初始化失敗',
  noCamera: '無攝像頭權限',
  secondTip: '金額不能少於{tip}',
  completePrice: '成交價',
  profitText: '收益',
  profitAndLoss: '预期收益和亏损',
  timeUp: '時間到',
  balanceText: '流水',
  closeAll: '一鍵全平',
  assetRate: '資金比例',
  cancel: '撤銷',
  cancelInfo: '確認撤銷？',
  buyCurrency: '認購幣',
  closeCurrency: '結算幣種',
  buyPrice: '認購價',
  valuation: '當前估值',
  profitP: '收益率',
  buySuccess: '認購成功',

  swiperTitle1: '全球頂尖數字貨幣交易所',
  swiperSub1: '超過十萬用戶的信賴',
  ieoBuying: '認購中',
  ieoOpen: '開始日期',
  ieoClose: '截止日期',
  about: '關於',
  ieoPlan: '分配計畫',
  ieoInfo: '認購信息',
  ieoContact: '社交媒體',
  ieoStart: '項目啟動',
  ieoBuyStart: '申購開始',
  ieoBuyEnd: '申購結束',
  ieoIsTrade: '上市交易',
  introduce: '簡介',
  ieoSubBuy: '認購',
  subBuyHistory: '認購歷史',
  rechargeTip1: '1、此地址是你最新和獨一無二的充值地址，平台在任何情況下都不會要求你向某一個賬戶轉賬，也不會向你索要驗證碼。',
  rechargeTip2: '2、充值需要至少10個網絡區塊進行確認，確認後，你的賬號將自動收到該筆充值資金。',
  withdrawTip1: '1、請確保你選擇的提幣網絡和你在相對應的該筆充幣所選擇的網絡一致，請確保平台支持你選擇的網絡，否則提幣將無法到賬或退回。',
  withdrawTip2: '2、平台審核通過你的提幣申請後，將提交給網絡區塊確認。',
  withdrawTip3: '3、提幣需要至少10個網絡區塊進行確認，確認後，你將自動收到該筆提幣資金。',
  coming: '即將開啟，敬請期待！',
  createTeam: '儲備基金',
  angelFund: '天使基金',
  ecology: '機構與生態系統',
  presale: '預售發行',
  mechanism: '挖礦機制',
  trading: '上市交易',

  issuePrice: '發行價',
  minBuyPrice: '最低認購額',
  buyNum: '每天認購次數',
  buyTotal: '每天認購總額',
  Increment: '認購遞增量',
  blockchain: '區塊鏈',

  sellTotal: '發行總量',
  currentBuy: '當前認購量',
  lessMinTip: '不能低於最低認購額',
  stakeAccount: '質押賬戶',
  serviceAccount: '服務賬戶',
  lock: '锁定',
  lockPrice: '锁定价格',
  ieoHistory: '認購記錄',
  lockHistory: '鎖定記錄',
  sellHistory: '賣出記錄',
  stake: '质押',
  service: '服务',
  ieoBuyTip: '*IEO提示：GPTH數量有限。我們將審核用戶的IEO申請並每3小時隨機抽籤一次。金額較大的用戶購買GPTH的概率較高。每個用戶每天最多可以購買3次。',
  ieoLockTip: '*鎖定價格：用戶需要使用USDT作為質押幣種，才可以鎖定GPTH的價格，質押比例為GPTH價值的30%。 GPTH上市後，用戶可按當時鎖定的價格將GPTH賣出。',
  ieoSellTip: '*認購賣出：賣出GPTH需要收取GPTH價值的10%作為服務費，賣出的GPTH後，你兌換的USDT將於20天后解凍，質押的USDT將於20天后解凍。',
  whitePaper: '白皮書',
  cost: '成本',
  currentEstimate: '當前估值',
  stakeNum: '質押數量',
  estimate: '估值',
  consume: '消耗',

  seedSell: '種子輪',
  privateSell: '私募基金',
  openSell: 'KOL',
  ieoAward: '公開發售',
  ieoGrowUp: '團隊',
  partner: '顧問',
  consultant: '市場營銷',
  ieoName: '流動性',
  conAward: 'AI To Earn',
  staking: '質押',

  release: '釋放',
  closedTime: '平倉時間',
  remark: '備註',

  totalProfit: '總盈虧',
  transferIn: '轉入',
  transferOut: '轉出',
  equity: '淨值',

  
  homeremind1: '流行的加密貨幣',
  homeremind2: '看更多市場',
  homeremind3: '最新價格(USD)',
  homeremind4: '24小時變化',
  homeremind5: '行動',
  homeremind6: '看更多',
  homeremind7: "用戶的最佳選擇",
  homeremind8: '24小時交易量',
  homeremind9: '優質虛擬資產',
  homeremind10: '我們的核心產品',
  homeremind11: '多種交易工具可供選擇',
  homeremind12: '法幣',
  homeremind13: '超過 700 種加密貨幣可供交易',
  homeremind14: '透過合约交易提升您的體驗',
  homeremind15: 'FTZINC Earn',
  homeremind16: '業界最佳 APY',
  homeremind17: '我們的多元化服務',
  homeremind18: '透過我們多元化的服務探索無限可能',
  homeremind19: 'IEO認購',
  homeremind20: "最有價值的數位貨幣",
  homeremind21: '專屬客服服務',
  homeremind22: '7*24線上客服',
  homeremind23: '社群',
  homeremind24: '與我們一起發現財富機會',
  homeremind25: '隨時隨地進行交易。 隨時隨地。',
  homeremind26: '透過我們的應用程式和桌面用戶端隨時了解情況。',
  homeremind27: '在社群媒體上關注我們',
  homeremind28: '隨時了解我們的最新消息',
  homeremind29: '隨時隨地進行交易',
  homeremind30: '使用您的 iOS、Android 或 API 嘗試 FTZINC。',

  ieoDes: `數位資產智慧應用鏈（Digital Asset Smart Application Chain，簡稱 DAS）,旨在建立一個基於區塊鏈技術的數位資產智慧應用生態系統，打破傳統資產流通障礙。`,
  ieoDes1: `透過將個人資產分散化處理，為用戶提供多元化的鏈上資產營運服務，實現資產的高效融資、增值、質押與貸款，助力用戶獲取穩定且可觀的回報收益，推動數位資產領域的創新發展與合規應用。`,

  ieoDes10: `能源生態儲備智慧鏈（ERS）是一個創新的區塊鏈項目，它將區塊鏈技術與全球能源生態系統儲備需求結合。其核心目標是解決全球能源短缺和突發事件中能源供應安全的挑戰。`,
  ieoDes11: `該計畫依賴由來自多個國家的產業領袖組成的核心團隊，建構去中心化的能源生態系統儲備智慧平台。該平台連接整個能源產業鏈，涵蓋研發、應用、安全和運輸等環節。透過代幣經濟體系，平台激勵生態系統共建，實現能源資源的智慧配置、生態儲存與全球流通。`,
  ieoDes12: `該項目發行ERS代幣作為生態系統的唯一代幣。透過科學的代幣分配和清晰的上線路線圖，ERS推動專案實施和生態系統發展，為全球能源安全提供區塊鏈技術解決方案。`,





  foundingTeam: '创始团队',
  managementTeam: '管理团队',
  investors: '投资机构',
  ecologicalFund: '生态基金',
  presaleNew: '预售发行',
  stakingNew: '挖矿分配',
  publicTrading: '上市交易',

  aboutName: '關於FTZINC',
  aboutContent: `<p><strong>FTZINC 今日</strong></p><p><span style="font-family: 宋体;">如今，FTZINC 是一家全球性公司，在美國、英國、澳洲、塞浦路斯、直布羅陀、波蘭、保加利亞和塞席爾設有辦事處。在短短的時間內，我們已成為歐洲發展最快的投資交易平台之一，實現了三位數的同比增長，全球團隊規模在短短兩年內增長了五倍。</span></p><p><span style="font-family: 宋体;">但歸根究底，我們是一家以人為本的企業。我們根植於科技與創新，建構了一個賦能平台，賦能人們，讓他們充分發揮潛能。</span></p><p><span style="font-family: 宋体;">無論您的動機是什麼——無論是學習新技能、增加財富，還是要求企業對其行為負責——我們都致力於幫助您實現交易和投資目標。</span></p><p><span style="font-family: 宋体;">值得信賴的全球投資交易平台屢獲殊榮，並由英國金融行為監管局、塞浦路斯證券交易委員會、澳洲證券和投資委員會、塞席爾金融服務管理局和巴哈馬證券委員會授權和監管。</span></p><p><span style="font-family: 宋体;">我們承諾為您提供卓越的全天候客戶服務和透明的定價，零佣金、無隱藏費用、低隔夜費和極具競爭力的點差。</span></p><p> </p><p><strong>我們的願景</strong></p><p><span style="font-family: 宋体;">幾十年來，金融服務一直由富人經營，服務富人。 FTZINC 的創辦人希望改變這種現狀。我們的使命是顛覆傳統金融，讓交易更容易實現。</span></p><p><span style="font-family: 宋体;">我們致力於讓每個人都能進入金融市場。從這個簡單的想法出發，一場革命誕生了——一場由普通人引領的革命，他們掌控著局面，並改變了他們的生活、他們的財務未來，最重要的是，改變了世界的未來。</span></p><p><span style="font-family: 宋体;">因此，當散戶開始支持特斯拉，幫助其打造全球最有價值的公司之一時，他們不僅在投資一隻擁有革命性技術的成長型股票，更是在投資一個更美好未來——一個更永續的未來。儘管氣候活動家和政客也發揮各自的作用，但特斯拉的股價才是整個化石燃料汽車產業走向電動化的決定性因素。</span></p><p><span style="font-family: 宋体;">而 FTZINC 始終如一地支持並推動著這場散戶革命。自2016年成立以來，我們一直致力於運用科技的力量，開拓交易和投資選擇，打破傳統過時的進入門檻。</span></p><p><span style="font-family: 宋体;">如今，我們基於網頁和應用程式的全球平台支援超過400萬交易者，幫助他們改變生活、改變金融未來，甚至改變世界。</span></p><p><br></p>`,

  detailName0: '儲值',
  detailName1: '提現',
  detailName2: '凍結',
  detailName3: '凍結解除',
  detailName4: '幣幣市價交易',
  detailName5: '幣幣限價交易',
  detailName6: '合約市價交易',
  detailName7: '合約限價交易',
  detailName8: '合約平倉',
  detailName9: '認購交易',
  detailName10: '儲值',
  detailName11: '提現凍結',
  detailName12: '提現成功扣除',
  detailName13: '提現拒絕返還',
  detailName14: '劃轉',
  detailName15: '合約開倉',
  detailName16: '爆倉強平',
  detailName17: '退款-提款取消',
  detailName19: '質押借貸凍結',
  detailName20: '質押借貸拒絕',
  detailName21: '質押借貸',
  detailName22: '質押借貸還款',
  detailName23: '質押借貸結清',

  usersAgreementsTitle: '使用者協定',
  usersAgreements: `<p>1. FTZINC<span style="font-family: 宋体;">為全球區塊鏈資產交易愛好者提供。</span> <span style="font-family: 宋体;">本協議已載明與您的權益有或可能有重大關係的條款，以及平台有或可能有免除或限制責任的條款，請您注意。</span> <span style="font-family: 宋体;">您確認，在您註冊成為本平台使用者接受本服務之前，您已充分閱讀、瞭解並接受本協議的全部內容。</span> <span style="font-family: 宋体;">一旦您使用本服務，即表示您同意遵守本協議的全部條款。</span></p><p>2<span style="font-family: 宋体;">、您同意本平台有權隨時單方變更本協議內容，並更新並展示在服務協議頁面，無需單獨通知您；</span> <span style="font-family: 宋体;">如果您在本協議內容變更公告後繼續使用本服務，則表示您已充分閱讀、瞭解並接受修改後的協議內容，並將依照修改後的協議內容使用本服務</span>; <span style="font-family: 宋体;">如果您不同意修改後的協議內容，您應停止使用本服務。</span></p><p>3<span style="font-family: 宋体;">、您保證，當您同意接受本協議並註冊成為本平台使用者時，您已年滿</span>18<span style="font-family: 宋体;">歲；</span> <span style="font-family: 宋体;">本協議的內容不被您所在國家或地區的法律排除。</span> <span style="font-family: 宋体;">如果您不符合前述條件，您應立即終止註冊或停止使用本服務。</span></p><p>1. <span style="font-family: 宋体;">帳戶使用限制</span></p><p>1.1 <span style="font-family: 宋体;">您在使用本服務時，應遵守您所在國家或地區的法律法規及相關國際慣例，不得利用本服務用於任何非法目的（包括禁止或限制交易物品的交易），也不得用於任何非法目的。非法方式使用此服務。</span></p><p>1.2 <span style="font-family: 宋体;">您不得利用本服務從事侵害他人合法權益的行為，否則本平台有權追究、拖延或拒絕解決或拒絕提供本服務，且您應獨立承擔一切相關責任法律責任，由此造成本平台或本平台員工受傷的，您應承擔賠償責任。</span></p><p><span style="font-family: 宋体;">上述行為包括但不限於：</span></p><p>A<span style="font-family: 宋体;">。</span> <span style="font-family: 宋体;">侵犯他人名譽、隱私、商業機密等合法權益。</span></p><p>b. <span style="font-family: 宋体;">違反法律規定或約定的保密義務。</span></p><p>C<span style="font-family: 宋体;">。</span> <span style="font-family: 宋体;">以他人名義使用該服務。</span></p><p>d. <span style="font-family: 宋体;">從事非法交易，例如洗錢、恐怖融資、毒品交易或其他平台認為不宜使用服務的情況。</span></p><p>e. <span style="font-family: 宋体;">從事任何可能含有電腦病毒或可能侵犯服務系統和資料的行為。</span></p><p>F<span style="font-family: 宋体;">。</span> <span style="font-family: 宋体;">進行與您或交易對方申報的交易內容不符或不真實的交易。</span></p><p>G<span style="font-family: 宋体;">。</span> <span style="font-family: 宋体;">其他本平台因正當理由認為不適當的行為。</span></p><p>2.FTZINC<span style="font-family: 宋体;">仲介服務</span></p><p><span style="font-family: 宋体;">其中包含：</span></p><p>2.1 <span style="font-family: 宋体;">託管：您可以依照本服務指定的方式為您的</span>FTZINC<span style="font-family: 宋体;">帳戶（包括比特幣及本平台支援的其他數位資產，下同）充值，並委託本平台代為保管。</span></p><p>2.2 <span style="font-family: 宋体;">結算：對於您與本平台其他使用者之間的交易，平台將作為第三方提供數位資產（不涉及各國法定貨幣）的交易結算服務。</span> <span style="font-family: 宋体;">您同意，在平台結算後，除非本協議約定，否則付款不可撤銷。</span></p><p>2.3 <span style="font-family: 宋体;">提現：您可以向本平台要求支付您委託本平台管理的數位資產金額。</span> <span style="font-family: 宋体;">當您向平台發送提幣指令時，您必須驗證您在平台設定的驗證方式是否有效。</span> <span style="font-family: 宋体;">平台將在規定時間內（具體以平台規定為準）收到驗證成功指令，並將相應數量的資產轉入您提供的有效交割地址。</span></p><p>2.4<span style="font-family: 宋体;">查詢：您可以在本系統即時查詢您帳戶名稱下的交易記錄。</span></p><p>2.5 <span style="font-family: 宋体;">資金獨享：平台將保留您向本平台支付的、屬於您帳戶的數位資產份額，不會將其用於非您指示的任何其他用途。</span></p><p>3.註冊相關</p><p>您必須直接在本網站註冊並取得本平台向您提供的帳戶。 你同意：</p><p>3.1 依照平台要求準確提供並在取得帳戶後及時更新您正確、最新、完整的驗證資訊。 如果平台有理由斷定您提供的資訊不正確、不是最新的或不完整，而平台要求您提供任何相關信息，如果您不能及時提供，我們有權拒絕您的信息訪問本網站並終止或暫停您的帳戶。</p><p>3.2 您應準確、及時更新您所提供的電子郵件地址及其他聯絡方式，以便本平台及時有效地與您聯繫。 由於透過這些聯絡方式無法與您取得聯繫而給您在使用本服務過程中產生的任何損失或費用增加以及其他不良後果，由您自行承擔。 您瞭解並同意，您有義務保持您提供的聯絡資訊的有效性。 如有變更需要更新的，您應按照本平台的要求進行操作。</p><p>3.3 您的帳戶不得包含誤導性或欺詐性訊息，包括但不限於使用非自然人的身分認證資訊、非自然人的銀行帳戶等。</p><p>3.4 因您未及時更新資訊（包括但不限於本平台帳戶綁定的手機號碼、電子郵件地址等），導致服務無法提供或提供時出現錯誤，您不得以此作為取消交易或拒絕付款的理由，您將承擔由此產生的一切後果，本平台不承擔任何責任。</p><p>3.5 您對您的帳戶負責，只有您可以使用您的帳戶。</p><p>3.6 您同意，如果您喪失全部或部分民事權利能力或民事行為能力，本平台有權根據有效法律文件（包括但不限於生效的法院判決書、有效遺囑等）文章。</p><p>3.7 我們可以隨時要求您完成我們的身分驗證流程，如果我們認為有必要，我們也可能要求您向本平台提交額外的身分證明文件。 未完成身份驗證將被視為違反本協議。</p><p>3.8 如果您違反，我們可能會關閉、暫停或限制您存取您的帳戶或我們提供的其他服務，和/或限制您的數位資產餘額的使用180 天（或更長時間，如果根據法院命令或其他法律程序）這些服務條款或任何其他協議。 在評估與您的帳戶相關的風險時，我們也可以使用專有的風險評估模型，高風險的使用者將被視為違反本協議。</p><p>3.9 根據本協議的條款，如果我們確定您在之前任何時間點違反了本協議或任何其他協議，我們還可以關閉、暫停或限制您的帳戶和數位資產餘額用於服務您正在使用 和其他措施。</p><p>4. 帳戶安全</p><p>您將對使用該帳號和密碼的所有操作和言論負全部責任。 你同意：</p><p>4.1 本平台透過您的帳號登入名稱、密碼等指示辨識您的指令。 您應妥善保管您的帳戶登入名稱和密碼，因密碼外洩而造成的損失由您自行承擔。 您承諾不向任何人透露您的帳號登入名稱和密碼，也不使用任何人的登入名稱和密碼。 本平台也可能利用本服務應用您使用的其他產品或裝置來識別您的指示。 您應妥善保管或控制這些產品或設備。 對於因這些產品或設備遺失而造成的任何損失，由您負責。</p><p>4.2 您同意：（a）如您發現他人冒用、盜用您的帳戶登入名稱和密碼，或有其他未經授權的使用行為，您應立即以有效方式通知平台，並要求平台暫停相關服務； (b) 確保您在連續登入期間結束時以正確的步驟離開網站。 本平台不能也不會對您未遵守本條款而發生的任何損失、損壞及其他不良後果負責。 您了解本平台需要合理的時限才能對您的請求採取行動。 在此之前，平台不會對已執行的指令和/或由此對您造成的損失負責。</p><p>4.3 除非有法律規定或司法判決，並經本平台同意，您的帳戶登入名稱、密碼、帳戶不得以任何方式轉讓、贈與或繼承（相關財產權除外）。</p><p>4.4 您同意，基於營運和交易安全的需要，本平台可以暫時停止提供或限製本服務的部分功能，或提供新的功能。 當任何功能減少、增加或變更時，只要您仍使用本服務，即表示您仍同意本協議或變更後的協議。</p><p>4.5 本平台有權了解您使用平台產品或服務的真實交易背景及目的。 您應如實提供平台要求的真實、全面、準確的資訊； 若平台有合理理由懷疑您提供虛假交易資訊的，本平台有權暫時或永久限制您使用的產品或服務的部分或全部功能。</p><p>4.6 您同意，為了您的帳戶及其數位資產的安全，根據本協議、法律法規、法律文件的規定、政府依據行政權力的要求以及平台自行判斷可能影響的您的帳戶一旦出現風險，平台有權凍結您名下的全部或部分帳戶，即暫時關閉部分或全部帳戶。 凍結的逆過程是解凍，即平台結束對被凍結帳戶的凍結。 發生凍結時，如您申請解凍，平台有權依前述凍結原因依本規定決定是否允許全部或部分解凍。 您應充分瞭解，您的解凍申請不一定被允許，且申請解凍時，您應配合本平台的相關要求驗證您的身份，並提供包括但不限於身份資訊、身分證、護照、其他有效身分證件及本平台要求的其他資訊或文件。</p><p>5 帳戶使用規則</p><p>為了有效保護您在使用本服務時的合法權益，您了解並同意接受以下規則：</p><p>5.1 您一旦使用本服務，即表示您授權本平台代理您與符合規定條件的使用者之間的數位資產結算。</p><p>5.2 本平台透過以下兩種方式接受您的指示：一是您使用您的帳戶名稱和密碼登入您在本網站的帳戶，並依照本服務預設流程修改或確認交易狀態或指示； 其次，您透過電子郵件、手機或其他專用於您的通訊工具作為您註冊時的帳戶名稱或與該帳戶綁定的帳戶回覆系統發送的資訊。 無論您是否透過上述兩種方式向平台發出指令，該指令均不可撤回或撤銷，並成為平台代表您付款或收款或進行其他帳戶操作的唯一指令。 它被視為您自己的指令。 您應對平台忠實執行上述指令而產生的任何結果負責。 除本協議另有規定外，當您與第三方發生交易糾紛時，您授權本平台自行判斷並決定向交易一方或雙方支付全部或部分爭議金額。</p><p>5.3 本平台將透過電子郵件（或發送簡訊或電話至手機等方式）通知您交易進度並提示您進行下一步操作，但本平台不保證您一定能收到或收到該電子郵件及時（或發送簡訊或電話至手機等），且不承擔任何後果，因此，您在交易過程中應及時登入本網站查看並進行交易操作。 由於您未能及時查看、修改或確認交易狀態或未提交相關申請而引起的任何爭議或損失，本平台不承擔任何責任。</p><p>5.4 本協議項下數位資產的轉移是透過相應的網路實現的，您瞭解並同意您的數位資產轉移過程中的合理時間。</p><p>5.5 交易風險</p><p>A。 使用本服務時，如果您或您的交易指示出現錯誤（包括但不限於價格、數量等因素），導致您的交易損失，您將自行承擔損失。</p><p>b. 因您的過錯造成的任何損失由您自行承擔。 故障包括但不限於：未依照交易提示操作、未及時進行交易操作、密碼遺忘或洩漏、密碼被他人破解、您的電腦被他人入侵等。</p><p>C。 在使用本服務時，如因網站交易系統或規則中潛在的未被發現的漏洞而給您帶來不正當收益，本站有權聯繫您追償，您必須有效配合，否則本站追索措施包括，但採取的措施包括但不限於限制帳戶交易、凍結帳戶資金、訴訟等。 由於您未能有效配合而為我們帶來的追索費用也將由您承擔。</p><p>5.6. 您瞭解並同意，因下列情況造成的任何損害，包括但不限於利潤、貨物、資料等損失，本平台不承擔責任：</p><p>A。 本平台有權根據單方判斷，暫停、中斷或終止提供本服務或您名下帳戶的任何部分，包括但不限於本平台認為您違反了本協議的明示規定和精神。同意，並刪除您的數據。</p><p>b. 本平台在發現異常交易或疑似違反法律或本協議規定的情況時，有權不經通知而暫停或終止您名下帳戶的使用（包括但不限於您名下帳戶的使用）。 支付及途中交易採取取消交易、帳戶調整等限制措施），並拒絕使用本服務的部分或全部功能。</p><p>6.服務費用</p><p>6.1 當您使用本服務時，本平台有權依照《帳戶服務收費規則》向您收取服務費用。 本平台擁有服務費的製定與調整權。 具體服務費用以您使用服務時本網站所公佈的收費方式或您與平台達成的其他書面協議為準。</p><p>6.2 除非另有說明或同意，您同意本平台有權從您委託本平台管理、收取或支付的款項中直接扣除上述服務費用。</p><p>七、隱私保護</p><p>一旦您同意本協議或使用本服務，即表示您同意本平台依照以下條款使用和揭露您的個人資訊。</p><p>7.1 帳號登入名稱和密碼</p><p>當您註冊帳戶和服務時，我們會要求您設定帳戶登入名稱和密碼以識別您的身份，並設定手機簡訊驗證和實名認證以在您遺失密碼時確認您的身份。 您只能使用您設定的密碼的帳戶。 如果您洩露密碼，您可能會遺失您的個人識別訊息，並可能給您帶來不利的法律後果。 當您的帳戶、密碼因任何原因面臨潛在或實際危險時，您應立即聯絡平台。 在平台採取行動之前，平台對此不承擔任何責任。</p><p>7.2 註冊信息</p><p>您在註冊時應提供電話號碼、電子郵件地址等相關資訊。 為了有針對性地為您提供新的服務和機會，您瞭解並同意本平台將透過您的聯絡方式（包括但不限於手機、郵箱等）向您發送相關通知及其他商業電子訊息。 。</p><p>7.3 交易行為</p><p>為了保障您使用服務的安全以及不斷提高服務質量，本平台會記錄並保存您登錄、使用本服務的相關信息，但本平台承諾不將該信息提供給任何第三方（除非雙方另有約定或法律法規另有規定的除外）。</p><p>7.4 您同意，為了更安全、有效地向您提供服務，根據法律法規規定，或平台需要識別您的身份，或平台認為您的帳戶存在風險，平台有權要求您您提交的身份資訊（包括但不限於身分證、戶口簿、護照等證件或其他證件）。 除本協議另有規定外，</p><p> </p><p>A。 事先獲得您的明確授權；</p><p>b. 依本協議的要求揭露；</p><p>C。 依法律、法規的規定；</p><p>d. 依照政府主管機關的要求；</p><p>e. 為維護本平台的合法權益。</p><p>7.5 外部鏈接</p><p>本網站含有其他網站的鏈接，但本平台不對其他網站的隱私保護措施負責。 本平台可能會在必要時新增業務合作夥伴或共享品牌網站。</p><p>7.6 安全</p><p>本平台僅根據現有技術提供相應的安全措施，以防止本平台持有的資訊遺失、濫用和變造。 這些安全措施包括將資料備份到其他伺服器和加密使用者密碼。 儘管有這些安全措施，本平台並不保證這些資訊的絕對安全。</p><p>8. 系統中斷或故障</p><p>當系統因下列情況而無法正常運作，導致您無法使用各項服務時，本平台不承擔損害賠償責任，包括但不限於：</p><p>8.1 平台網站公告的系統停機維護期間。 8.2 電信設備無法傳輸資料。</p><p>8.3 由於颱風、地震、海嘯、洪水、停電、戰爭、恐怖攻擊等不可抗力因素，導致本平台系統因係統障礙而無法執行。</p><p>8.4 因駭客攻擊、電腦病毒侵入或攻擊、電信部門的技術調整或故障、網站升級、因政府管製而暫時關閉以及其他影響網路正常運作的原因造成的服務中斷或延遲。</p><p>8.5 使用者進行不當操作或以未經平台授權或認可的方式使用平台服務。</p><p>8.6 用戶的電腦軟硬體、通訊線路、供電線路發生故障。</p><p>九、責任範圍和責任限制</p><p>本平台僅對本協議規定的責任範圍負責。</p><p>9.1 本平台的使用者資訊由使用者本人提供，本平台無法保證資訊的準確性、有效性和完整性。</p><p>9.2 平台可能同時為您和您的（交易）對方提供平台服務。 您同意明確免除平台可能存在的此類行為的任何實際或潛在的利益衝突，並且您不得聲稱平台提供平台。 服務存在法律缺陷。</p><p>9.3 若您透過使用本服務下載或取得任何數據，您應自行考慮並自行承擔風險。 由於下載資料而導致您的電腦系統損壞或資料遺失，您應承擔全部責任。</p><p>9.4 您從本平台及其工作人員或透過本服務獲得的建議和訊息，無論是書面或口頭形式，均不構成平台對本服務的保證。</p><p>10. 完整協議</p><p>本協議由本協議條款及本網站所公佈的《服務收費規則》等規則組成。 相關術語可以互相引用、引用。 如有不同理解，以本協議條款為準。 如果您瞭解並同意本協議，則您瞭解並同意本協議的所有組成部分。 一旦您使用本服務，您和本平台將受本協議所有組成部分的約束。 本協議部分內容被有管轄權的司法機關認定為違法的，不影響其他內容的效力。</p><p>11. 商標和智慧財產權的保護</p><p>11.1 本網站所有內容，包括但不限於作品、圖片、文件、資訊、資料、網站架構、網站畫面排列、網頁設計等，均依法歸平台所有，包括但不限於商標權、專利權、版權、商業秘密等</p><p>11.2 未經本平台書面同意，任何人不得擅自使用、修改、複製、公開傳播、變更、散佈、發布或公開發表本網站的程序或內容。</p><p>11.3 尊重智慧財產權是您的義務。 如有違反，您應承擔損害賠償責任。</p><p>十二、法律適用及管轄</p><p>本協議的效力、解釋、修改、執行及爭議解決均適用平台所在地法律。 如果沒有相關法律規定，請參閱一般國際商業慣例和/或行業慣例。 因本協議產生的爭議，應依照平台所在地法律處理，並以平台所在地司法機關為第一審管轄地。</p>`,

  privacyPolicyTitle: '隱私權政策',
  privacyPolicy: `<p><span style="font-family: 宋体;">本隱私權聲明適用於</span>FTZINC<span style="font-family: 宋体;">的所有相關服務。</span> FTZINC<span style="font-family: 宋体;">尊重並保護所有使用</span>FTZINC<span style="font-family: 宋体;">平台服務的使用者的個人隱私。</span> <span style="font-family: 宋体;">為了提供您更準確、個人化的服務，它將按照本隱私權政策的規定使用和揭露您的個人信息，但</span>FTZINC<span style="font-family: 宋体;">將以高度勤勉、審慎的態度對待這些資訊。</span> <span style="font-family: 宋体;">除本隱私權政策另有規定外，未經您事先許可，</span>FTZINC <span style="font-family: 宋体;">不會向第三方揭露或提供這些資訊。</span> FTZINC<span style="font-family: 宋体;">將不時更新本隱私權政策。</span> <span style="font-family: 宋体;">您在同意</span>FTZINC<span style="font-family: 宋体;">服務協議之時，即視為您已同意本隱私權政策全部內容。</span> <span style="font-family: 宋体;">本隱私權政策屬於服務協議不可分割的一部分。</span></p><p>1. <span style="font-family: 宋体;">使用範圍</span></p><p><span style="font-family: 宋体;">當您註冊或啟動可登入我們平台的帳戶時，您在我們關聯公司提供的其他平台上提供的個人註冊資訊（根據法律法規規定需要公開的企業名稱等相關商業登記資訊除外）</span> <span style="font-family: 宋体;">、自然人經營者資訊；當您使用</span>FTZINC<span style="font-family: 宋体;">或</span>FTZINC<span style="font-family: 宋体;">網頁時，</span>FTZINC<span style="font-family: 宋体;">還會記錄您的瀏覽器和計算機上的信息，包括但不限於您的</span>IP<span style="font-family: 宋体;">地址、瀏覽器類型、使用的語言、訪問日期和時間、軟體資料例如您所需的硬體特徵資訊和網頁記錄；透過</span>FTZINC<span style="font-family: 宋体;">從商業夥伴取得的使用者個人資料。</span></p><p>2. <span style="font-family: 宋体;">資訊的使用</span></p><p><span style="font-family: 宋体;">我們不會向任何無關第三方提供、出售、出租、分享或交易您的個人信息，除非事先獲得您的許可，或者該第三方與我們（包括我們的關聯公司）單獨或共同向您提供服務，且服務結束後，將被禁止存取其曾經使用過的所有這些資料。</span></p><p><span style="font-family: 宋体;">之前可以訪問。</span> <span style="font-family: 宋体;">我們也不允許任何第三方以任何方式收集、編輯、出售或傳播您的個人資訊。</span> <span style="font-family: 宋体;">若本平台用戶有上述行為，一經發現，我們有權立即終止與該用戶的服務協議。</span></p><p><span style="font-family: 宋体;">三、資訊揭露</span></p><p><span style="font-family: 宋体;">在下列情況下，我們會根據您的個人意願或法律規定全部或部分披露您的個人資訊：</span> <span style="font-family: 宋体;">經您事先同意，向第三方披露；</span> <span style="font-family: 宋体;">如果您是合格的智慧財產權投訴人並已提出投訴，應被投訴人的要求，向被投訴人披露，以便雙方處理可能存在的權利糾紛；</span> <span style="font-family: 宋体;">依法相關規定或行政、司法機構的要求，向第三方或行政、司法機構揭露；</span> <span style="font-family: 宋体;">如果您違反相關法律、法規，或我們的服務協議或相關規則需要向第三方揭露；</span> <span style="font-family: 宋体;">為了提供您要求的產品和服務，您必須與第三方分享您的個人資訊；</span> <span style="font-family: 宋体;">在我們平台上創建的交易中，如果交易任何一方履行或部分履行了交易義務並提出信息披露請求的，我們有權決定向用戶提供交易對方的聯繫方式等必要信息，以方便該用戶的知情同意。交易的完成或爭議的解決。</span> <span style="font-family: 宋体;">我們根據法律、法規或網站政策進行我們認為適當的揭露。</span></p><p>4.<span style="font-family: 宋体;">資訊儲存與交換</span></p><p><span style="font-family: 宋体;">我們收集的有關您的資訊和資料將儲存在我們和（或）其附屬公司的伺服器上。</span> <span style="font-family: 宋体;">這些資訊和資料可能會傳輸到您所在的國家、地區或我們收集資訊和資料所在的境外，並在境外被存取、儲存和顯示。</span></p><p>5. Cookie <span style="font-family: 宋体;">的使用</span></p><p><span style="font-family: 宋体;">如果您不拒絕接受</span>cookies<span style="font-family: 宋体;">，我們將在您的電腦上設定或存取</span>cookies<span style="font-family: 宋体;">，以便您可以登入或使用依賴</span>cookies<span style="font-family: 宋体;">的我們的平台服務或功能。我們使用</span>cookies<span style="font-family: 宋体;">為您提供更周到、個人化的服務，包括促銷服務。</span> <span style="font-family: 宋体;">您有權選擇接受或拒絕接受</span>cookies<span style="font-family: 宋体;">。</span> <span style="font-family: 宋体;">您可以透過修改瀏覽器設定來拒絕接受</span>cookies<span style="font-family: 宋体;">。</span> <span style="font-family: 宋体;">但如果您選擇拒絕接受</span>cookies<span style="font-family: 宋体;">，您可能無法登入或使用依賴</span>cookies<span style="font-family: 宋体;">的我們的平台服務或功能。</span> <span style="font-family: 宋体;">透過</span>FTZINC<span style="font-family: 宋体;">設定的</span>cookies<span style="font-family: 宋体;">取得的相關資訊將適用本政策；</span></p><p>6. 資訊安全</p><p>您的帳戶有安全保護功能，請妥善保管您的帳戶和密碼資訊。 我們會採用備份到其他伺服器、對使用者密碼進行加密等安全措施，確保您的資訊不會遺失、不被濫用和變造。 儘管有前述安全措施，但請注意，資訊網路上不存在「完善的安全措施」。 在使用我們的平台服務進行線上交易時，您不可避免地要向交易對方或潛在的交易對方披露您的個人資訊，例如聯絡資訊或郵寄地址。 請您妥善保護您的個人訊息，僅在必要時提供給他人。 如果您發現您的個人資訊尤其是您的帳號和密碼洩密，請立即聯絡我們的客服，以便我們採取相應措施。 未成年人特別注意事項如果您不是具有完全民事權利能力和完全民事行為能力的自然人，您無權使用我們的平台服務，因此我們希望您不要向我們提供任何個人資訊。</p><p>您的帳戶服務被終止或帳戶在FTZINC的權限被永久凍結（註銷）後，FTZINC沒有義務為您保留或向您披露您帳戶中的任何信息，也沒有義務向您轉發任何您未讀過的信息或第三方或發送的訊息。</p><p>您同意，您與FTZINC的合約關係終止後，FTZINC仍享有以下權利：繼續保存您的用戶資訊以及您使用FTZINC服務期間的所有交易資訊。 如果您在使用FTZINC服務過程中存在違法行為或違反本協議和/或規則的，FTZINC仍可依據本協議向您主張權利。</p><p>FTZINC暫停或終止向您提供FTZINC服務後，您在暫停或終止服務前的交易將按照以下原則處理，您應自行處理並完全承擔任何爭議、損失或任何額外費用由以下處理產生。 也應確保FTZINC不會因此而遭受任何損失或產生任何費用： 如果您在服務暫停或終止之前上傳到FTZINC的虛擬貨幣（例如比特幣和其他虛擬貨幣）尚未進行交易，FTZINC有權已與其他會員達成買賣合同，但該合約尚未實際履行的，FTZINC有權刪除該買賣合約以及與比特幣等虛擬貨幣相關的資訊。虛擬貨幣； 您在暫停或終止服務前已與其他會員達成銷售合約且已部分履行的，FTZINC不得刪除該交易，但FTZINC有權在暫停或終止服務時將相關情況通知您的交易對方。</p><p>7. 隱私權政策</p><p>FTZINC 將不時在 FTZINC 網站上公佈和修改其隱私權政策。 本隱私權政策構成本協議的有效組成部分。</p>`,

  legalStatementTitle: '法律聲明',
  legalStatement: `<p><strong>第一條：</strong></p><p><span style="font-family: 宋体;">本網站旨在不違反美國相關法律法規的情況下，最大程度地為世界各地的數位資產愛好者和投資者提供專業、安全、值得信賴的數位資產交易和資產管理服務。</span> <span style="font-family: 宋体;">但如果您所在國家或地區屬於明確禁止數位資產交易的司法管轄區或列入受制裁國家名單的司法管轄區，您應避免使用本網站提供的服務。</span></p><p><strong>第二條：</strong></p><p><span style="font-family: 宋体;">本平台致力於為使用者打造合規、安全、可靠的數位資產交易環境。</span> <span style="font-family: 宋体;">禁止使用者利用本網站從事洗錢、走私、商業賄賂、惡意操縱市場等非法交易活動或違法活動。</span> <span style="font-family: 宋体;">有鑑於此，我們盡最大努力製定嚴格的反洗錢和反恐方案，並採取有效的安全風險控制措施，最大限度地維護用戶的合法權益，維護平台的良好聲譽</span></p><p><strong>第三條：</strong></p><p><span style="font-family: 宋体;">當有權機關依據相關調查令要求平台配合調查特定用戶，或對該用戶的帳戶採取關閉、凍結帳戶、劃轉帳戶資產等措施時，網站應在核實該授權書的有效性和真實性後，向有權機關提供使用者的相關資料或進行相應操作，以便依照有權機關的要求協助調查。</span> <span style="font-family: 宋体;">對於因用戶隱私洩露或用戶無法操作其帳戶而導致用戶遭受的任何直接或間接損失，該平台不承擔任何責任。</span></p><p><strong>第四條：</strong></p><p><span style="font-family: 宋体;">使用本網站提供的服務的使用者在進行交易前應注意：數位資產沒有任何政府或中央銀行的支持，數位資產的價格存在較大波動，並且持有或持有使用數位資產面臨重大風險。</span> <span style="font-family: 宋体;">有鑑於此，您在做出交易決定之前，應理性、審慎評估自身的財務狀況，以確定擬進行的交易是否適合您。</span></p><p><strong>第五條：</strong></p><p><span style="font-family: 宋体;">如果本網站使用者違反本聲明任何規定，從而觸犯塞席爾共和國任何相關法律，本網站作為本服務的提供者，有義務完善平台的規則和服務，但前提是本網站沒有任何違反美國此類相關法律的動機，也沒有任何違反此類法律的事實；</span> <span style="font-family: 宋体;">因此，本網站不對該使用者的任何行為承擔連帶責任。</span></p><p><strong>第六條：</strong></p><p><span style="font-family: 宋体;">使用者以任何方式登入本網站，或直接、間接使用本網站服務，即視為同意本聲明內容，並自願同意受本聲明的約束。</span></p><p><strong>第七條：</strong></p><p><span style="font-family: 宋体;">本聲明未盡事宜，請參閱美國相關法律法規。</span> <span style="font-family: 宋体;">當本聲明與美國任何相關法律法規相衝突時，以美國相關法律法規為準。</span></p>`,

  launderingPolicyTitle: '反洗錢政策',
  launderingPolicy: '<p><span style="font-family: 宋体;">第</span>1<span style="font-family: 宋体;">條：</span></p><p><span style="font-family: 宋体;">制定目的和依據</span> <span style="font-family: 宋体;">鑑於洗錢活動會嚴重危害數位資產交易的發</span>​​<span style="font-family: 宋体;">展，助長和滋生腐敗，破壞社會風氣，損害用戶合法權益，動搖數位資產交易的基礎。數位資產交易平台穩定運作。</span> <span style="font-family: 宋体;">為防止洗錢和恐怖融資活動，</span>FTZINC<span style="font-family: 宋体;">依照《</span>FTZINC<span style="font-family: 宋体;">反洗錢規則》、《客戶協議》、《大額交易》履行反洗錢和反恐怖融資法律的相關規定。</span> <span style="font-family: 宋体;">」。</span> <span style="font-family: 宋体;">根據《管理辦法》等公司規章制度，制定本指引。</span></p><p><span style="font-family: 宋体;">第二條：</span></p><p><span style="font-family: 宋体;">適用範圍本指引適用於所有在</span>FTZINC<span style="font-family: 宋体;">交易平台上參與交易的使用者。</span> <span style="font-family: 宋体;">使用者應遵守所在國家或地區有關反洗錢、反恐怖主義融資的法律法規，並在使用者所在地區法律規定的範圍內執行本指南的規定。</span> <span style="font-family: 宋体;">如果使用者所在國家或地區有更嚴格的要求，則按照其規定執行。</span></p><p><span style="font-family: 宋体;">第三條：</span></p><p><span style="font-family: 宋体;">反洗錢、反恐融資是指防止犯罪者透過</span>FTZINC<span style="font-family: 宋体;">平台進行交易，包庇、包庇毒品犯罪、黑社會性質的組織犯罪、恐怖活動犯罪、走私犯罪、貪污賄賂犯罪、對金融詐騙犯罪、破壞金融管理秩序犯罪等違法所得和洗錢活動的來源和性質，依照相關法律和</span>FTZINC<span style="font-family: 宋体;">反洗錢規定採取相關措施。</span></p><p><span style="font-family: 宋体;">第四條：</span></p><p>FTZINC<span style="font-family: 宋体;">反洗錢相關規定</span> FTZINC<span style="font-family: 宋体;">反洗錢（包括反恐怖融資，下同）相關規則包括《</span>FTZINC<span style="font-family: 宋体;">反洗錢規則》、《用戶協議》反洗錢部分，以及《大額交易管理辦法》並附本指引。</span> <span style="font-family: 宋体;">若本指南規定的內容與其他規則相衝突，以本指南為準。</span></p><p><span style="font-family: 宋体;">第五條：</span></p><p>FTZINC<span style="font-family: 宋体;">反洗錢的基本原則是依照下列原則進行顧客風險監控工作：</span></p><p><span style="font-family: 宋体;">全面性原則。</span> FTZINC<span style="font-family: 宋体;">平台將綜合考慮客戶可能涉及洗錢的各種風險因素，並採取合理的方法監控所有客戶的風險。</span></p><p><span style="font-family: 宋体;">審慎原則。</span> FTZINC<span style="font-family: 宋体;">平台將在充分了解客戶的基礎上，提高客戶識別能力，並審慎監控客戶風險。</span></p><p><span style="font-family: 宋体;">永續性原則。</span> FTZINC<span style="font-family: 宋体;">平台將持續專注於客戶風險，並根據實際情況適當應對。</span></p><p><span style="font-family: 宋体;">保密原則。</span> FTZINC<span style="font-family: 宋体;">平台所持有的客戶識別資訊、交易資訊、風險等級資訊均嚴格保密，除非符合法律法規和監管要求，不會提供給任何單位和個人。</span></p><p><span style="font-family: 宋体;">分級管理的原則。</span> FTZINC<span style="font-family: 宋体;">平台根據客戶的風險等級定期審核所儲存的客戶基本資料。</span> <span style="font-family: 宋体;">風險等級較高的客戶的審核應比對風險等級較低的客戶的審核更嚴格。</span></p><p><span style="font-family: 宋体;">第六條：</span></p><p><span style="font-family: 宋体;">個人使用者文件的提交</span>FTZINC<span style="font-family: 宋体;">個人使用者應依照</span>FTZINC<span style="font-family: 宋体;">反洗錢規定提交以下資訊和資料：</span></p><p><span style="font-family: 宋体;">個人姓名</span></p><p><span style="font-family: 宋体;">身分證、護照、駕照等有效證件；</span></p><p><span style="font-family: 宋体;">應</span>FTZINC<span style="font-family: 宋体;">要求提供的其他資訊或文件。</span></p><p><span style="font-family: 宋体;">第七條：</span></p><p><span style="font-family: 宋体;">機構使用者文件的提交</span>FTZINC<span style="font-family: 宋体;">機構使用者應依照</span>FTZINC<span style="font-family: 宋体;">反洗錢規定提交以下資訊和資料：</span></p><p><span style="font-family: 宋体;">公司名稱</span>;</p><p><span style="font-family: 宋体;">公司註冊辦公室地址；</span></p><p><span style="font-family: 宋体;">公司法定代理人；</span></p><p><span style="font-family: 宋体;">公司法定代理人住所；</span></p><p><span style="font-family: 宋体;">商業執照</span>;</p><p><span style="font-family: 宋体;">本公司法定代理人身分證或護照影本；</span></p><p><span style="font-family: 宋体;">應</span>FTZINC<span style="font-family: 宋体;">要求提供的其他資訊或文件。</span></p><p>第八條：</p><p>審查使用者文件。 FTZINC平台將依照FTZINC反洗錢規定中的客戶識別系統對客戶提交的相關資訊進行驗證並記錄。 平台對客戶提交的資訊如有疑問的，有權向相關主管機關或部門核實。</p><p>第九條：</p><p>低風險用戶的監控 FTZINC 平台將根據 FTZINC 反洗錢法規的具體要求檢測低風險用戶。 FTZINC平台保留調整低風險用戶等級的權利。</p><p>第十條：</p><p>高風險用戶的監控 FTZINC 平台將每六個月對高風險客戶進行審查，更新客戶身分的基本資訊並了解資金來源、資金用途、經濟狀況或營運狀況。</p><p>第十一條：</p><p>使用者文件的保存 FTZINC平台將依法採取必要措施，在一定期限內保存客戶身分資料和交易資訊。 參考國際通行規則，使用者身分資訊應在業務關係結束後保存至少五年，客戶交易資訊在交易結束後應保存至少五年。</p><p>第十二條：</p><p>使用者註意 FTZINC使用者應注意以下事項： 禁止將使用者自己的帳戶出借給他人；</p><p>禁止出租、出借用戶身分證明；</p><p>禁止出租、出借、洩漏使用者本人帳戶、銀行卡、存摺、密碼等重要個人財產資訊；</p><p>使用者應積極配合FTZINC平台進行客戶識別；</p><p>在FTZINC平台進行交易時，選擇並使用安全可靠的第三方金融機構進行支付活動。</p><p>第十三條：</p><p>舉報可疑行為如果FTZINC平台用戶在平台交易過程中發現任何帳戶可能從事洗錢或恐怖融資活動，用戶可以向FTZINC平台舉報。</p><p>第十四條：</p><p>指引解釋 本指南由FTZINC平台負責說明。</p><p>第十五條：</p><p>有效期限 本指引自發布日起施行。</p>',
  
  tradeMin100: '最低交易金額：100 USDT',
  cancelled: '撤銷',

  phone: '電話（可選）',
  phone1: '電話',

  start1: '註冊',

  toTrade: '立即交易',

  openRecord: '開倉記錄',
  closeRecord: '平倉記錄',

  closeOrder: '關閉訂單',


  swiperTitle2: '用於購買、出售、交易、持有和賺取加密貨幣的一體化加密平台。',
  swiperSub2: '我們已經指導了數百萬全球用戶的數位資產之旅。',


  homeremind31: '購買加密貨幣',
  homeremind32: '你支付',
  homeremind33: '你獲得',
  homeremind34: '價格將重新計算',
  homeremind35: '條款與條件',
  homeremind36: '立即購買',
  homeremind37: 'FTZINC 是一個適合所有人的一站式平台',
  homeremind38: '客戶',
  homeremind39: '支持的國家',
  homeremind40: '季度交易量',

  homeremind41: '如何開始',
  homeremind42: '建立帳戶',
  homeremind43: '登入 FTZINC 註冊新的個人資料',
  homeremind44: '驗證您的身份',
  homeremind45: '花費不到 5 分鐘即可完成驗證程序。',
  homeremind46: '首先建立您的帳戶',
  homeremind47: '購買和存入加密貨幣',
  homeremind48: '為您的 FTZINC 帳戶添加資金以存取加密貨幣服務。',
  homeremind49: '首先驗證您的身份',
  homeremind50: '開始你的旅程',


  homeremind51: '探索 FTZINC 生態系統內的加密貨幣機會',
  homeremind52: '首先購買並存入加密貨幣',
  homeremind53: '建立您的加密貨幣投資組合',
  homeremind54: '購買加密貨幣',
  homeremind55: '為什麼選擇FTZINC？',
  homeremind56: '簡單',
  homeremind57: 'FTZINC 讓使用我們的行動應用程式輕鬆購買加密貨幣。',
  homeremind58: '教育',
  homeremind59: '不知道從哪裡開始？ 前往我們的學習中心，了解加密貨幣的所有知識。',

  homeremind60: '服務',
  homeremind61: '在我們的支援中心立即找到您的答案,或透過電子郵件 24/7/365 與我們聯絡。',
  homeremind62: '開始使用 FTZINC',


  selectText: '查詢', 


  ieointro1: `創始團隊`,
  ieointro2: `天使基金`,
  ieointro3: `生態應用`,
  ieointro4: `預售階段`,
  ieointro5: `挖礦生成`,


  ieointro10: `創始團隊`,
  ieointro11: `天使基金`,
  ieointro12: `生態系統`,
  ieointro13: `預售分配`,
  ieointro14: `挖礦獎勵`,


  tradename: '交易',



  swiperTitle3: '尋找下一代交易所',
  swiperTitle4: '在FTZINC上交易數位貨幣',
  swiperTitle5: `加密貨幣交易所 {'|'} 保證金交易 {'|'} 加密貨幣衍生性商品`,

  homeremind64: '立即註冊',
  homeremind65: '覆蓋國家',
  homeremind66: '全球投資者',
  homeremind67: '幣',
  homeremind68: '24小時交易量',

  homeremind69: 'Scan QR Code to Download App',//No need
  homeremind70: '電子郵件地址',

  homeremind71: '新幣預售',
  homeremind72: 'View all 700+ coins', //No need

  homeremind73: 'Coming Soon',//No need
  homeremind74: '認購',

  homeremind75: '熱門榜',
  homeremind76: '漲幅榜',
  homeremind77: '跌幅榜',

  homeremind78: '立即嘗試世界領先的加密貨幣交易所',
  homeremind79: `安全{'|'}免手續費{'|'}快速{'|'}去中心化`,
  homeremind80: 'View more benefits',//No need
  homeremind81: '只需一步即可使用電子郵件地址註冊並立即進行交易',


  homeremind82: '探索 FTZINC 產品和服務',
  homeremind83: '幣幣交易',
  homeremind84: '使用我們一整套強大的工具進行加密貨幣交易，以最大限度地提高您的利潤。',
  homeremind85: '購買加密貨幣',
  homeremind86: '在我們受歡迎且業界領先的平台上快速輕鬆地購買加密貨幣。',
  homeremind87: '加密貨幣衍生性商品',
  homeremind88: '我們是交易加密貨幣期貨的最佳加密貨幣交易所。',
  homeremind89: 'FTZINC Earn',//No need
  homeremind90: 'Invest and earn steady income with the help of a professional asset manager.',//No need
  homeremind91: 'Trading Bot',//No need
  homeremind92: 'Earn passive income round-the-clock without having to constantly monitor markets.',//No need
  homeremind93: '保證金交易',
  homeremind94: '透過保證金交易充分利用您的資產。',
  homeremind95: 'Leveraged Tokens',//No need
  homeremind96: 'Amplify your investment returns by simply buying and selling leveraged tokens.',//No need
  homeremind97: 'Halo Wallet',//No need
  homeremind98: 'A self-custody social wallet that allows you to easily discover, invest, and earn.',//No need

  homeremind99: '您安全可靠的加密貨幣交易所',
  homeremind100: '安全資產存儲',
  homeremind101: '我們業界領先的加密和儲存系統確保您的資產始終安全可靠。',
  homeremind102: '強大的帳戶安全性',
  homeremind103: '我們遵守最高的安全標準並實施最嚴格的安全實踐，以確保您的帳戶安全。',
  homeremind104: '值得信賴的平台',
  homeremind105: '我們擁有適當的安全設計基礎，以確保快速偵測和回應任何網路攻擊。',
  homeremind106: 'PoR——資產透明度',
  homeremind107: 'PoR（儲備證明）--是一種廣泛使用的證明區塊鏈上資產託管的方法，確認 FTZINC 擁有涵蓋我們帳簿上所有用戶資產的資金。',

  homeremind108: 'Learn More',//No need
  homeremind109: '隨時隨地進行交易',
  homeremind110: 'FTZINC 應用程式和網站可讓您輕鬆交易加密貨幣。',
  
  
  homeremind111: '24/7 客戶服務',
  homeremind112: '您的問題，已解答。 如有疑問，請隨時聯絡 FTZINC 客戶支援。',
  homeremind113: 'FTZINC Help Center',//No need
  homeremind114: '加入我們的社區',
  homeremind115: 'FTZINC 全球社群擁有來自 100 多個國家的數百萬用戶，支援 20 多種語言。',
  homeremind116: '英語社區',
  homeremind117: 'View all 20+ languages',//No need
  homeremind118: 'FTZINC在你身邊',
  homeremind119: '立即開始您的加密之旅！',
  
  appDownload: 'App 下載',
  androidDownload: 'Android 下載',
  iosDownload: 'iOS下載',

  funding: '現貨',


  successText: '成功', 

  withdrawTip4: `溫馨提示：每筆提現申請將扣除`,
  withdrawTip5: `的手續費，提領任何金額的訂單都是只扣除`, 
  withdrawTip6: `。`, 


  homeremind212: '資產總額',
  homeremind213: '儲值',
  homeremind214: '幣幣',
  homeremind215: '合約',
  homeremind216: '預售',
  homeremind217: '只需 30 秒即可註冊',
  homeremind218: '全球主流數位貨幣',
  homeremind219: '立即交易',
  homeremind220: 'DAS預售開啟',
  homeremind221: '最熱門的IEO項目',
  homeremind222: '訂閱',
  homeremind223: '合約交易上線',
  homeremind224: '高達200倍槓桿',


  emailCheck: '郵箱驗證碼', 


  ieoIntro: '代幣簡介',
  homeSentence1: `7*24小時服務`,
  homeSentence2: `全日制營運模式`,
  homeSentence3: `滿足各種場景的交易需求`,
  homeSentence4: `隨時隨地 開啟交易`,


  lastStep: `上一步`,


  commodities: '大宗商品',





  forgotPassword: `忘記密碼？`,
  registerText: `還沒有帳號？`,
  registerText1: `在此註冊`,

  loginText: `登入您的帳戶`,
  loginText1: `已有帳號？`,
  loginText2: `在此登入`,

  loginPolicy: `註冊即表示我同意服務條款以及隱私權政策中所述的個人資料處理方式。`,
  registerPolicy: `登入即表示我同意服務條款以及隱私權政策中所述的個人資料處理方式。`,

  loginLayoutText: `全球超過150萬用戶信賴之選。隨時為您服務。`,

  homeSwiperTitle: `在最佳加密貨幣交易平台上進行現貨、槓桿、期貨和場外交易`,
  homeSwiperText: `專業交易，人人適用。`,

  startTrading: '開始交易',
  exploreMarkets: '探索市場',

  downloadOn: `下載`,
  getItOn: `開始吧`,

  homeCoinListSentence: `適合初學者和專業交易員`,
  homeCoinListSentence1: `買賣和管理`,
  homeCoinListSentence2: `超過100種加密資產`,
  homeCoinListSentence3: `探索所有加密資產`,

  homeWhyChooseSentence: `為什麼選擇 FTZINC？`,
  homeWhyChooseSentence1: `全球超過150萬用戶首選的加密貨幣交易所`,
  //homeWhyChooseSentence2: `more than 1.5 million users globally`,
  homeWhyChooseSentence3: `有效市場`,
  homeWhyChooseSentence4: `在 FTZINC 的流動性強的現貨、現貨保證金和永續期貨市場交易 100 多種加密資產，並配備一系列訂單類型和交易工具。`,
  homeWhyChooseSentence5: `靈活收益產品`,
  homeWhyChooseSentence6: `利用我們簡單易用的流動性質押解決方案來獲取收益，我們將為您處理在線質押的複雜性。`,
  homeWhyChooseSentence7: `世界一流的API`,
  homeWhyChooseSentence8: `我們的機構級 API 提供即時和歷史市場數據、共享帳戶和極具競爭力的費率限制。`,
  homeWhyChooseSentence9: `輕鬆貨幣轉換`,
  homeWhyChooseSentence10: `您可以透過我們簡易的買賣兌換終端、銀行轉帳或場外交易平台，輕鬆將各種貨幣兌換成加密貨幣。`,
  homeWhyChooseSentence11: `客戶支援`,
  homeWhyChooseSentence12: `我們根據客戶的需求量身定制服務，提供快速高效的客戶支持，並為企業合作夥伴提供專屬支援管道。`,
  homeWhyChooseSentence13: `快速入職`,
  homeWhyChooseSentence14: `我們的自動化註冊流程完全符合 KYC 和 AML 標準，並高度重視資料隱私，可在幾分鐘內完成。`,

  homeQuicklyStartSentence: `快速開始交易`,
  homeQuicklyStartSentence1: `幾分鐘即可開始`,
  //homeQuicklyStartSentence2: `in minutes`,
  homeQuicklyStartSentence3: `開戶`,
  homeQuicklyStartSentence4: `幾分鐘即可建立並驗證您的帳戶`,
  homeQuicklyStartSentence5: `為您的帳戶儲值`,
  homeQuicklyStartSentence6: `您可以透過銀行轉帳存入法幣，也可以直接存入加密貨幣為您的帳戶充值。`,
  homeQuicklyStartSentence7: `開始交易`,
  homeQuicklyStartSentence8: `交易超過 100 種加密資產，支援現貨、現貨保證金和期貨交易，或整合我們強大的 API，最大程度地提高您的交易收益。`,

  homeGetStartSentence: `專業交易`,
  homeGetStartSentence1: `，為了所有人。`,
  homeGetStartSentence2: `開始使用`,

  homeOurInvestorsSentence: `我們的投資者`,



  favorites: '收藏夾',
  original: '基礎K線',



  indices: `指數`,
  indicesNotAllowOpen: `市場休市期間不允許開倉`,
  indicesNotAllowClose: `市場休市期間不允許平倉`,
  indicesNotAllowSet: `市場休市期間不允許修改訂單`,
  


  tokenIntroduction: `代幣介紹`,
  newWhitepaper: `白皮書`,


  kbfIntro1: `由新加坡量子資產管理私人有限公司（Quantum Asset Management Pte Ltd）主導開發的肯塔基蝴蝶農場（KBF）是第一個基於AMM（自動做市商）的資產交易公共區塊鏈。它基於全球會計做市商機制（AMM）、區塊鏈遊戲和社交基礎設施構建，作為一個超級計算系統，能夠為商業應用提供強大的支持，並支持包括AMM、GameFi和SocialFi在內的多種服務的快速部署。`,

kbfIntro2: `KBF公共區塊鏈網路技術展現出多項優勢。其最顯著的特點是高效能，使KBF區塊鏈能夠處理更多交易並實現更快的交易確認速度。在數位金融領域，速度和效率是衡量服務品質的關鍵指標。透過持續優化其技術架構，KBF區塊鏈成功提升了交易處理能力，為用戶帶來更快、更有效率的金融服務體驗。`,

kbfIntro3: `其次，KBF公共區塊鏈展現出卓越的可擴展性。隨著數位金融市場的快速發展，用戶群和應用需求不斷擴大。為了滿足這一不斷增長的需求，KBF區塊鏈從一開始就將未來的網路可擴展性納入了設計考量。利用 AMM（自動做市）和零知識證明技術，它能夠輕鬆應對用戶流量和交易量的激增，確保網路穩定運作和永續發展。`,


  
}
